export type ApprovalLikelihood = 'marginal' | 'low' | 'moderate' | 'good' | 'high' | 'optimal' | 'veryHigh'

// Conversion-probability model (story 66451): P(x) = P_MIN + (P_MAX - P_MIN) * (1 - e^(-LAMBDA * x)).
export const CONVERSION_MODEL = {
  P_MIN: 0.3,
  P_MAX: 0.8,
  LAMBDA: 10,
} as const

// merchantFeeRate: decimal fraction (e.g. 0.15 = 15%), domain [0, 0.30].
export const conversionProbability = (merchantFeeRate: number): number =>
  CONVERSION_MODEL.P_MIN +
  (CONVERSION_MODEL.P_MAX - CONVERSION_MODEL.P_MIN) * (1 - Math.exp(-CONVERSION_MODEL.LAMBDA * merchantFeeRate))

// Lower bound (inclusive) of each tier's fee-rate band. The top tier has no upper bound — mirrors
// the source model's own lookup (greatest lower bound <= x), so merchantFeeRate === MERCHANT_FEE_RATE_MAX
// (30%) never falls outside every band.
export const APPROVAL_LIKELIHOOD_TIERS: { threshold: number; level: ApprovalLikelihood }[] = [
  { threshold: 0, level: 'marginal' },
  { threshold: 0.015, level: 'low' },
  { threshold: 0.03, level: 'moderate' },
  { threshold: 0.05, level: 'good' },
  { threshold: 0.1, level: 'high' },
  { threshold: 0.15, level: 'optimal' },
  { threshold: 0.2, level: 'veryHigh' },
]

const TIERS_DESCENDING = [...APPROVAL_LIKELIHOOD_TIERS].reverse()

export const getApprovalLikelihood = (merchantFeeRate: number): ApprovalLikelihood =>
  TIERS_DESCENDING.find((tier) => merchantFeeRate >= tier.threshold)!.level
